<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("projects.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('projects.name') })" v-model="form.name" :label='$t("projects.name")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="customers" :label='$t("projects.customer")' disable-match :danger="$v.form.customer_id.$invalid && $v.form.customer_id.$model" :danger-text="$t('validation.required', { attribute: $t('customers.name') })" :serializer="item => item.name" required :data="catalog.customers" :placeholder='$t("projects.customer_placeholder")' v-model="form.customer_id" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc" :default-value="form.customer && form.customer.name")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("projects.location_placeholder")' :danger="$v.form.location.$invalid && $v.form.location.$model" :danger-text="$t('validation.required', { attribute: $t('projects.location') })" v-model="form.location" :label='$t("projects.location")')
      vm-col(vm-justify="center", vm-align="center", vm-w=5.5)
        b-form-group
          vm-select(:placeholder='$t("projects.country_placeholder")' :danger="$v.form.country.$invalid && $v.form.country.$model" :danger-text="$t('validation.required', { attribute: $t('projects.country') })" v-model="form.country" :label='$t("projects.country")' :default-value="form.country")
            vm-select-item(:key="index" :value="item" :text="item" v-for="(item,index) in countries")
      vm-col(vm-justify="center", vm-align="center", vm-w=5.5)
        b-form-group
          vm-input(autofocus :placeholder='$t("projects.price_placeholder")' :danger="$v.form.price.$invalid && $v.form.price.$model" :danger-text="$t('validation.required', { attribute: $t('projects.price') })" v-model="form.price" :label='$t("projects.price")' type="currency")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("projects.iva_placeholder")' :danger="$v.form.iva.$invalid && $v.form.iva.$model" :danger-text="$t('validation.required', { attribute: $t('projects.iva') })" v-model="form.iva" :label='$t("projects.iva")')
            vm-select-item(:key="index" :value="item" :text="item+'%'" :default="item[0]" v-for="(item,index) in iva_types")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          span {{ $t("projects.total_price") }}
          br
          br
          span {{ totalPrice(form.price, form.iva) | currency }}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')

export default {
  name: 'ModalProjects',
  mixins: [ModalMixin1],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    countries: [
      'MÉXICO',
      'EUA'
    ],
    iva_types: [
      '0',
      '8',
      '16'
    ]
  }),
  validations () {
    return {
      form: {
        name: {
          required
        },
        customer_id: {
          required
        },
        location: {
          required
        },
        country: {
          required
        },
        price: {
          required
        },
        iva: {
          required
        },
        total_price: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ]),
    totalPrice (price, iva) {
      this.form.total_price = ((parseFloat(price) * parseFloat(iva)) / 100) + parseFloat(price)
      return this.form.total_price ? this.form.total_price : '0'
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.$emit('closeModal')
    },
    saveRecord () {
      this.isAdd ? this.addRecord(this.form) : this.editRecord(this.form)
      this.$emit('updateRecords', this.form)
      this.close()
    }
  }
}
</script>
